import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { TsCodeType } from '../types.js'
import { Code } from '../types.js'

@jsonClass('UserDefinedConfiguration')
export class UserDefinedConfiguration extends BusinessObject {
	@jsonProperty(String)
	tsType: TsCodeType = ''
	@jsonProperty(Code)
	defaultValue = new Code('undefined')

	constructor(init?: Partial<UserDefinedConfiguration>) {
		super()
		assignCommonProperties(this, init)
	}

	getClassNames(): string[] {
		return [this.getQualifiedName()]
	}
}
